import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Button, Checkbox, Form, Select } from "antd";
import axios from "axios";
import { SelectCustom } from "./selectComponent";
import { manejarError } from "../manejo_errores";
import { InfoCircleOutlined, PlusOutlined, SmileOutlined } from "@ant-design/icons";
import { BotonPrincipal } from "./btnPrincipal";

export const ModalNotificacion = ({
  open,
  onCancel,
  datos,
  id_asociacion,
  HeadersAuth,
  setAlerta
}) => {
  // console.log("datos que llegan a modal", datos)
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const [tiposDestino, setTiposDestino] = useState([]);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    title: "",
    body: "",
    id_tipo_destino: "",
    id_tipo_screen: "",
    categorias: "",
    pilotos: ""
  });
  const [categorias, setCategorias] = useState([]);
  const [pilotos, setPilotos] = useState([]);
  const [tiposScreen, setTiposScreen] = useState([]);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchNotificacionesPuntuales();
    setSeleccionadas([]);
    limpiarCampos();
  }, [open, onCancel])

  useEffect(() => {
    setError("");
  }, [tempDatosFormulario.id_tipo_destino, tempDatosFormulario.categorias, tempDatosFormulario.pilotos, seleccionadas]);

  const fetchNotificacionesPuntuales = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/${id_asociacion}`, 
        HeadersAuth
      );
      // console.log("response.data", response.data)
      const { tiposDestino, tiposScreen } = response.data;
      setTiposDestino(tiposDestino);
      setTiposScreen(tiposScreen);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const toggleSeleccion = (index, checked) => {
    setSeleccionadas(prev =>
      checked ? [...prev, index] : prev.filter(n => n !== index)
    );
  };

  // Enviar notificación a todos los pilotos
  const enviarATodos = async () => {
    try {
      const notificacionesAEnviar =
        datos.length === 1
          ? datos
          : datos.filter((n, index) => seleccionadas.includes(index));

      if (notificacionesAEnviar.length === 0) {
        setError("Debés seleccionar al menos una notificación.");
        return;
      }

      if (tempDatosFormulario.id_tipo_destino.length === 0) {
        setError("Debés seleccionar al menos un destino a enviar.");
        return;
      }
      // console.log("notis a enviar", notificacionesAEnviar)
      const payload = {
        notificaciones: notificacionesAEnviar.map(n => ({
          title: n.title,
          body: n.body,
          id_tipo_screen: n.id_tipo_screen,
          id_tipo_disparador: n.id_tipo_disparador,
          id_carrera: n.id_carrera,
          id_categoria: n.id_categoria,
        })),
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos
      };
      // console.log("lo que se envía:", payload)
      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/todos`,
        {
          ...payload,
          id_asociacion: id_asociacion,
        },
        HeadersAuth
      );

      manejarAlertas("success", "Notificación enviada con éxito.");
      await fetchNotificacionesPuntuales();
      limpiarCampos();
      onCancel();
    } catch (error) {
      const msg = error.response.data.error || manejarError(error);

      setError(msg || "Ocurrió un error al enviar las notificaciones.");
      // console.log("ERROR:", error.response.data.error);
    }
  }

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_destino === "2") {
      fetchCategorias();
    }
  }, [tempDatosFormulario.id_tipo_destino])

  // Obtener categorías de la asociación
  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/categorias/notificables`, HeadersAuth);
      // console.log("response cate", response.data)
      setCategorias(response.data)
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  }

  // Enviar notificaciones a categorías seleccionadas
  const enviarACategorias = async () => {
    try {
      const notificacionesAEnviar =
        datos.length === 1
          ? datos
          : datos.filter((n, index) => seleccionadas.includes(index));

      if (notificacionesAEnviar.length === 0) {
        setError("Debés seleccionar al menos una notificación.");
        return;
      }

      if (tempDatosFormulario.id_tipo_destino.length === 0) {
        setError("Debés seleccionar al menos un destino a enviar.");
        return;
      }

      const payload = {
        notificaciones: notificacionesAEnviar.map(n => ({
          title: n.title,
          body: n.body,
          id_tipo_screen: n.id_tipo_screen,
          id_carrera: n.id_carrera,
          id_categoria: n.id_categoria,
        })),
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos
      };
      // console.log("lo que se envía cates:", payload)
      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/categoria`,
        {
          ...payload,
        },
        HeadersAuth
      );
      manejarAlertas("success", "Notificación enviada con éxito.");
      await fetchNotificacionesPuntuales();
      limpiarCampos();
      onCancel();
    } catch (error) {
      const msg = error.response.data.error || manejarError(error);

      setError(msg || "Ocurrió un error al enviar las notificaciones.");
      // console.log("ERROR:", error.response.data.error);
    }
  }

  const handleCategoriaChange = (checkedIds) => {
    setTempDatosFormulario({
      ...tempDatosFormulario,
      categorias: checkedIds, // acá solo guardamos IDs [1,4,7]
    });
  };

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_destino === "3") {
      fetchPilotosNotificables();
    }
  }, [tempDatosFormulario.id_tipo_destino]);

  // Obtener pilotos
  const fetchPilotosNotificables = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/pilotos/notificables`,
        HeadersAuth
      );
      // console.log("response pilo", response.data)
      setPilotos(response.data);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  // Enviar notificación a pilotos seleccionados
  const enviarAPilotos = async () => {
    try {
      const notificacionesAEnviar =
        datos.length === 1
          ? datos
          : datos.filter((n, index) => seleccionadas.includes(index));

      if (notificacionesAEnviar.length === 0) {
        setError("Debés seleccionar al menos una notificación.");
        return;
      }
      
      if (tempDatosFormulario.id_tipo_destino.length === 0) {
        setError("Debés seleccionar al menos un destino a enviar.");
        return;
      }
      const payload = {
        notificaciones: notificacionesAEnviar.map(n => ({
          title: n.title,
          body: n.body,
          id_tipo_screen: n.id_tipo_screen,
          id_carrera: n.id_carrera,
          id_categoria: n.id_categoria,
        })),
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos
      };
      // console.log("lo que se envía cates:", payload)
      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/piloto`,
        {
          ...payload,
        },
        HeadersAuth
      );
      manejarAlertas("success", "Notificación enviada con éxito.");
      await fetchNotificacionesPuntuales();
      limpiarCampos();
      onCancel();
    } catch (error) {
      const msg = error.response.data.error || manejarError(error);

      setError(msg || "Ocurrió un error al enviar las notificaciones.");
      // console.log("ERROR:", error.response.data.error);
    }
  }

  const limpiarCampos = () => {
    setTempDatosFormulario({
      id_tipo_destino: "",
      categorias: [],
      pilotos: []
    });
  };

  const destinoSeleccionado = tiposDestino.find(
    (t) => String(t.id) === String(tempDatosFormulario.id_tipo_destino)
  );

  const textosDestino = {
    TODOS: "Se le enviará la notificación a todos los pilotos de la asociación.",
    CATEGORIAS:
      "Se le enviará la notificación a todos los pilotos de la/s categoría/as seleccionadas.",
    PILOTO: "Se le enviará la notificación a los pilotos seleccionados.",
  };

  const textoSelect =
    destinoSeleccionado
      ? textosDestino[destinoSeleccionado.codigo] ||
        "Este destino todavía no tiene un texto definido."
      : "Seleccioná una opción para ver a quién se envía la notificación.";

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={700}
      footer={[
        <>
          <Button
            style={{
              backgroundColor: "#233463",
              color: "#FFF"
            }}
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button 
            style={{
              backgroundColor: "#BA1721",
              color: "#FFF"
            }}
            onClick={
              tempDatosFormulario.id_tipo_destino === "1"
              ? enviarATodos
              : tempDatosFormulario.id_tipo_destino === "2"
              ? enviarACategorias
              : enviarAPilotos
            }
          >
            Enviar
          </Button>
        </>
      ]}
    >
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 
          className="titulos" 
          style={{ 
            fontSize: "1.8em", 
            fontWeight: 400 
          }}
        >
          {datos.length > 1 ? "Seleccione las notificaciones a enviar" : "¿Desea enviar una notificación?"}
        </h1>
      </section>
      {datos?.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
            alignItems: "center",
            marginTop: "1em",
            backgroundColor: "#FFF",
            borderRadius: 15,
            boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
            padding: 20,
            gap: 20,
            marginBottom: 10
          }}
        >
          <div
            style={{
              padding: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 360,
              border: "1px solid #233463"
            }}
          >
            <img
              src="/logo512.png"
              alt="Logo Asociación"
              style={{ height: "2em", objectFit: "contain" }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "row", gap: 20, justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <div>
              <p style={{ fontSize: "1.2em", fontWeight: 500 }}>
                {item.title}
              </p>
              <p style={{ fontSize: "1em", fontWeight: 400 }}>
                {item.body}
              </p>
            </div>
            <div>
              {datos.length > 1 && (
                <Checkbox
                  checked={seleccionadas.includes(index)}
                  onChange={(e) => toggleSeleccion(index, e.target.checked)}
                />
              )}
            </div>
          </div>
        </div>
      ))}
      <Row className="rowAdmin" gutter={16} align="center">
        <Col xs={24} sm={24} style={{ width: "100%" }}>
          <SelectCustom
            idCampo={"id_tipo_destino"}
            textoOpciones={"descripcion"}
            arrayOpciones={tiposDestino}
            nombreCampo={"Elegí como querés enviar las notificaciones:"}
            elPlaceholder={"Seleccioná una opción"}
            required={true}
            onChange={(e) =>
              setTempDatosFormulario(prev => ({
                ...prev,
                id_tipo_destino: e.target.value,
              }))
            }
            elValue={tempDatosFormulario.id_tipo_destino}
          />
        </Col>
        {/* <Col xs={24} sm={12} style={{ width: "100%" }}>
          <SelectCustom
            idCampo={"id_tipo_screen"}
            textoOpciones={"descripcion"}
            arrayOpciones={tiposScreen.length > 0 ? tiposScreen : []}
            nombreCampo={"Elegí la sección de la app:"}
            elPlaceholder={"Seleccioná una opción"}
            required={true}
            onChange={(e) =>
              setTempDatosFormulario(prev => ({
                ...prev,
                id_tipo_screen: e.target.value,
              }))
            }
            elValue={tempDatosFormulario.id_tipo_screen || datos?.id_tipo_screen}
          />
        </Col> */}
      </Row>
      <Row className="rowAdmin" gutter={16} align="center">
        <Col xs={24} sm={24} style={{ width: "100%" }}>
          {tempDatosFormulario.id_tipo_destino === "2" && (
            <Form.Item>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                  marginTop: 10
                }}
              >
                <span style={{ color: "#bbbbbb", marginBottom: "0.5em" }}>
                  Categorías disponibles:
                </span>
                <Checkbox.Group
                  value={tempDatosFormulario.categorias || []}   // → array de IDs
                  onChange={handleCategoriaChange}
                  style={{ width: "100%" }}
                >
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {categorias.map((categoria) => (
                      <label
                        key={categoria.id}
                        style={{
                          border: "1px solid #d5d5d5",
                          borderRadius: "6px",
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          gap: "6px",
                        }}
                      >
                        <Checkbox value={categoria.id} />
                        {categoria.categoria}
                      </label>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          )}
        </Col>
        <Col xs={24} sm={24} style={{ width: "100%", marginTop: 10 }}>
          {tempDatosFormulario.id_tipo_destino === "3" && (
            <Form.Item
              style={{ width: "100%" }}
            >
              <p className="nombre-campo">Pilotos disponibles</p>

              <Select
                mode="multiple"
                allowClear
                placeholder="Seleccioná uno o varios pilotos"
                style={{ width: "100%" }}
                value={tempDatosFormulario.pilotos || []}
                onChange={(values) =>
                  setTempDatosFormulario({ ...tempDatosFormulario, pilotos: values })
                }
                optionLabelProp="label"
              >
                {pilotos.map((piloto) => (
                  <Select.Option
                    key={piloto.id}
                    value={piloto.id}
                    label={piloto.nombreCompleto}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
                      <span>{piloto.nombreCompleto}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
      <Row className="rowAdmin" gutter={16} align="center">
        <Col xs={24} sm={24} style={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#FFFFFF",
              border: "1px solid #d5d5d5",
              borderRadius: 8,
              padding: "10px",
              marginTop: 10
            }}
          >
            <InfoCircleOutlined style={{ color: "blue" }}/>
            <p style={{ fontSize: 14, color: "#000", fontWeight: 400, textAlign: "center" }}>
              {textoSelect}
            </p>
          </div>
        </Col>
        <Col xs={24} sm={24} style={{ width: "100%" }}>
          {error && (
            <p style={{ color: "red", marginTop: "1em", textAlign: "center" }}>
              {error}
            </p>
          )}
        </Col>
      </Row>
    </Modal>
  )
}